module.exports = __webpack_public_path__ + "assets/images/pages/kfc/icon-kfc-2.png?3fba2a8d";